<div class="container">
  <div class="row">
    <div class="col-md-10 col-md-offset-1 wpb_text_column dd-faqs">
      @for (item of faqs; track item.question) {
        <p><strong>{{ item.question }}</strong></p>
        <p>{{ item.answer }}</p>
      }
    </div>
  </div>
</div>
